module.exports = "/_next/static/images/img10-1773159c06446c7f24cbfa466fc3ad7e.jpg";